import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/enviroments';
import {
  CompanyDebtorMinuteResolutionDTO,
  CloseMinuteRequestResponseDTO,
  UpdateMinuteRequestLineApiDTO,
  UpdateMinuteLineResponseDTO,
  ApproveCompaniesDebtorsRequestDTO,
  AllMinuteRequest,
  AllMinuteResponse,
  UpdateAvalMinute,
  AddOrRemoveWarrantiesMinuteRequestDTO,
  UpdateRLOwnerMinute,
  UpdateMinuteRequestMinuteConditionDTO
} from '../interface/minute-request.interface';
import { MinuteRequestKpiDTO } from '../interface/minute-request-kpis.interface';
import { MinuteRequestSnapshotDTO, MinuteRequestSpecialConditionDTO, nuevaDescripcion, nuevaDuracion } from '../interface/minute-detail';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';
import { LegacyScoring } from '../../../interface/legacy-scoring';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';

@Injectable({
  providedIn: 'root',
})
export class MinuteRequestService {
  constructor(private httpClient: HttpClient) {}

  public approveDebtorCompanyMinute(companyId: number,minuteRequestId: number) {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/debtor/${companyId}/approve`;
    return this.httpClient.post<CompanyDebtorMinuteResolutionDTO>(endpoint,null);
  }

  public rejectDebtorCompanyMinute(companyId: number, minuteRequestId: number) {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/debtor/${companyId}/reject`;
    return this.httpClient.post<CompanyDebtorMinuteResolutionDTO>(endpoint,null);
  }

  public pendingDebtorCompanyMinute(companyId: number, minuteRequestId: number) {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/debtor/${companyId}/pending`;
    return this.httpClient.post<CompanyDebtorMinuteResolutionDTO>(endpoint,null);
  }

  public closeMinuteRequest(minuteRequestId: number): Observable<CloseMinuteRequestResponseDTO> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/close/`;
    return this.httpClient.put<CloseMinuteRequestResponseDTO>(endpoint, null);
  }

  public sendMinuteRequestToComitee(minuteRequestId: number): Observable<ActionResponseDTO<boolean>> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/comitee`;
    return this.httpClient.put<ActionResponseDTO<boolean>>(endpoint, null);
  }

  public getMinuteRequestKpi(minuteRequestId: number): Observable<MinuteRequestKpiDTO> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/kpis/`;
    return this.httpClient.get<MinuteRequestKpiDTO>(endpoint);
  }

  public getMinuteSnapshot(minuteRequestId: number): Observable<MinuteRequestSnapshotDTO> {
    const endpoint =  `${environment.apiUrl}/minutes/${minuteRequestId}/snapshot`;
    return this.httpClient.get<MinuteRequestSnapshotDTO>(endpoint);
  }

  public getAllMinutes(request: AllMinuteRequest) : Observable<PageResult<AllMinuteResponse>> {
    let queryParams = new HttpParams()
    .set('page', request.page)
    .set('size', request.size)
    .set('search', request.search)
    .set('status', request.status)
    .set('sortOrder', request.sortOrder);
    const endpoint = `${environment.apiUrl}/minutes/obtenerMinutas/`;
    return this.httpClient.get<PageResult<AllMinuteResponse>>(endpoint, {params: queryParams});
  }

  public deleteMinute(request: Number): Observable<CompanyDebtorMinuteResolutionDTO> {
    const endpoint = `${environment.apiUrl}/minutes/${request}/eliminarMinuta`;
    return this.httpClient.delete<CompanyDebtorMinuteResolutionDTO>(endpoint);
  }

  updateMinuteRequestLine(request: UpdateMinuteRequestLineApiDTO): Observable<ActionResponseDTO<UpdateMinuteLineResponseDTO>> {
    const endpoint = `${environment.apiUrl}/minutes/${request.minuteRequestId}/line`;
    return this.httpClient.put<ActionResponseDTO<UpdateMinuteLineResponseDTO>>(endpoint,request);
  }

  public approveMinute(id: number, comment: string | null = null) {
    const endpoint = `${environment.apiUrl}/minutes/${id}/approve`;
    interface approvementComment{
      comment: string;
    }
    const data = <approvementComment> {};
    data.comment = comment;
    return this.httpClient.post<CloseMinuteRequestResponseDTO>(endpoint, data );
  }

  public approveReviewMinute(id: number, comment: string | null = null) {
    const endpoint = `${environment.apiUrl}/minutes/${id}/review/approve`;
    interface approvementComment{
      comment: string;
    }
    const data = <approvementComment> {};
    data.comment = comment;
    return this.httpClient.put<CloseMinuteRequestResponseDTO>(endpoint, data );
  }

  public rejectMinute(id: number, comment: string | null = null) {
    const endpoint = `${environment.apiUrl}/minutes/${id}/reject`;
    interface approvementComment{
      comment: string;
    }
    const data = <approvementComment> {};
    data.comment = comment;
    return this.httpClient.post<CloseMinuteRequestResponseDTO>(endpoint, data);
  }

  public updateMinuteSnapshot(id: number){
    const endpoint = `${environment.apiUrl}/minutes/${id}/snapshot`;
    return this.httpClient.put<MinuteRequestSnapshotDTO>(endpoint, null);
  }

  public updateDescription(id: number, request: nuevaDescripcion) {
    const endpoint = `${environment.apiUrl}/minutes/${id}/description`;
    return this.httpClient.put<nuevaDescripcion>(endpoint, request);
  }

  public updateDuration(id: number, request: nuevaDuracion) {
    const endpoint = `${environment.apiUrl}/minutes/${id}/UpdateDuration`;
    return this.httpClient.put<nuevaDuracion>(endpoint, request);
  }

  public getLegacyData(rut: string): Observable<LegacyScoring> {
    const endpoint = `${environment.apiUrl}/Equifax/${rut}/GetLegacyAdmin`;
    return this.httpClient.get<LegacyScoring>(endpoint);
  }
  
  public approveCompaniesDebtorsMinute(request: ApproveCompaniesDebtorsRequestDTO){ 
    const endpoint = `${environment.apiUrl}/minutes/${request.minuteRequestId}/debtors/approve`;
    return this.httpClient.post<ActionResponseDTO<number>>(endpoint, request);
  }

  public updateMinute(request:UpdateAvalMinute ): Observable<UpdateAvalMinute> {    
    const endpoint = `${environment.apiUrl}/minutes/updateAvalMinute`;    
    return this.httpClient.put<UpdateAvalMinute>(endpoint, request);
  }

  public updateRlOwnerMinute(request:UpdateRLOwnerMinute ): Observable<UpdateRLOwnerMinute> {    
    const endpoint = `${environment.apiUrl}/minutes/updateRlOwnerMinute`;    
    return this.httpClient.put<UpdateRLOwnerMinute>(endpoint, request);
  }

  public removeFactoringOperationMinute(minuteRequestId: number, invoiceOperationId: bigint): Observable<ActionResponseDTO<bigint>> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/invoiceOperation/${invoiceOperationId}`;
    return this.httpClient.delete<ActionResponseDTO<bigint>>(endpoint);
  }

  public insertFactoringOperationToMinute(minuteRequestId: number, invoiceOperationsId: bigint[]):Observable<ActionResponseDTO<any>> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/invoiceOperations/add`;
    const request = {
      invoiceOperationsId: invoiceOperationsId
    };
    return this.httpClient.post<ActionResponseDTO<any>>(endpoint, request);
  }

  public removeWarrantiesFromMinute(request: AddOrRemoveWarrantiesMinuteRequestDTO): Observable<ActionResponseDTO<number>> {
    const endpoint = `${environment.apiUrl}/minutes/${request.minuteRequestId}/warranties/remove`;
    return this.httpClient.post<ActionResponseDTO<number>>(endpoint, request);
  }

  public addWarrantiesToMinute(request: AddOrRemoveWarrantiesMinuteRequestDTO) : Observable<ActionResponseDTO<number>> {
    const endpoint = `${environment.apiUrl}/minutes/${request.minuteRequestId}/warranties/add`;
    return this.httpClient.post<ActionResponseDTO<number>>(endpoint, request);
  }

  public updateMinuteHasConditions(minuteRequestId: number): Observable<ActionResponseDTO<boolean | null>> {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/conditions`;
    return this.httpClient.put<ActionResponseDTO<boolean | null>>(endpoint, {});
  }

  public updateMinuteRequestMinuteConditions(minuteRequestId: number, conditions: UpdateMinuteRequestMinuteConditionDTO[]) {
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/conditions`;
    return this.httpClient.put<ActionResponseDTO<MinuteRequestSpecialConditionDTO[]>>(endpoint, conditions);
  }
  public removeMinuteConditionFromMinuteRequest(minuteRequestId: number, minuteRequestMinuteConditionId: bigint): Observable<ActionResponseDTO<boolean>>{
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/conditions/${minuteRequestMinuteConditionId}`;
  return this.httpClient.delete<ActionResponseDTO<boolean>>(endpoint);
  }

  public markMinuteRequestConditionAsViewed(minuteRequestId: number, minuteRequestMinuteConditionId: bigint){
    const endpoint = `${environment.apiUrl}/minutes/${minuteRequestId}/conditions/${minuteRequestMinuteConditionId}/review`;
    return this.httpClient.put<ActionResponseDTO<MinuteRequestSpecialConditionDTO | null>>(endpoint, null);
  }
}
